import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import map from "lodash.map";
import filter from "lodash.filter";
import isEmpty from "lodash.isempty";
import isEqual from "lodash.isequal";
import {
  Map as LeafletMap,
  TileLayer,
  Marker,
  Popup,
  Tooltip,
} from "react-leaflet";
import { RouteUrls } from "../../../../configs/routeUrls";
import { Loader } from "../../../Loader";
import { ButtonLoader } from "../../../ButtonLoader";
import { Select } from "../../../Select";
import {
  ThematicAreaDropdownOption,
  DistrictDropdownOption,
  BudgetYearDropdownOption,
  ProjectTaskStatusDropdownOption,
  PageSize,
} from "../../../../utils/enums";
import { divIcon } from "leaflet";

export class ProjectTaskMap extends Component {
  constructor(props) {
    super(props);

    this.map = null;
    this.state = {
      zoom: props.mapConfig.zoom,
      locationLatitude: props.mapConfig.latitude,
      locationLongitude: props.mapConfig.longitude,
      budgetYearId:
        props.budgetYearId !== BudgetYearDropdownOption.NotSetted
          ? props.budgetYearId
          : !isEmpty(props.budgetYears)
          ? props.budgetYears[0].id
          : BudgetYearDropdownOption.NotSetted,
      districtId: props.districtId || DistrictDropdownOption.NotSetted,
      officeThematicAreaId:
        props.officeThematicAreaId || ThematicAreaDropdownOption.NotSetted,
      status: props.status || ProjectTaskStatusDropdownOption.NotSetted,
      searchTerm: props.searchTerm || "",
    };

    this.zoomEnd = (e) => {
      let zoom = e.target.getZoom();
      this.setState({
        zoom: zoom,
      });
    };
    this.handleSelect = (fieldName, option) => {
      this.setState({
        [fieldName]: option.value,
      });
    };
    this.handleChange = (event) => {
      this.setState({
        searchTerm: event.target.value,
      });
    };
    this.handleInvalid = this._handleInvalid.bind(this);
    this.onSearchClick = this.onSearchProjectTasks.bind(this);
  }

  componentDidMount() {
    this.props.fetchProjectTasks({
      budgetYearId: this.state.budgetYearId,
      districtId: this.state.districtId,
      officeThematicAreaId: this.state.officeThematicAreaId,
      status: this.state.status,
      searchTerm: this.state.searchTerm,
      page: 1,
      size: PageSize.All,
    });
  }

  onSearchProjectTasks() {
    this.props.fetchProjectTasks({
      budgetYearId: this.state.budgetYearId,
      districtId: this.state.districtId,
      officeThematicAreaId: this.state.officeThematicAreaId,
      status: this.state.status,
      searchTerm: this.state.searchTerm,
      page: 1,
      size: PageSize.All,
    });
  }

  renderDistrictOptions() {
    const notSetted = {
      value: DistrictDropdownOption.NotSetted,
      text: "[Wszystkie obszary]",
    };
    const options = map(this.props.districts, (district, i) => ({
      value: district.id,
      text: district.name,
    }));

    return [notSetted, ...options];
  }

  renderBudgetYearOptions() {
    const options = map(this.props.budgetYears, (budgetYear, i) => ({
      value: budgetYear.id,
      text: budgetYear.year,
    }));

    return [...options];
  }

  renderOfficeThematicAreaOptions() {
    const notSetted = {
      value: ThematicAreaDropdownOption.NotSetted,
      text: "[Wszystkie kategorie]",
    };
    const options = map(
      filter(this.props.officeThematicAreas, {
        officeId: this.props.defaultOffice.id,
      }),
      (officeThematicArea, i) => ({
        value: officeThematicArea.id,
        text: officeThematicArea.name,
      })
    );

    return [notSetted, ...options];
  }

  renderStatusOptions() {
    const notSetted = {
      value: ProjectTaskStatusDropdownOption.NotSetted,
      text: "[Wszystkie statusy]",
    };
    const options = map(
      filter(this.props.projectTaskStatuses, (o) => o.id > 0),
      (projectTaskStatus, i) => ({
        value: projectTaskStatus.id,
        text: projectTaskStatus.name,
      })
    );

    return [notSetted, ...options];
  }

  _handleInvalid(e) {
    e.target.setCustomValidity("");
    if (!e.target.validity.valid) {
      if (!e.target.value) {
        e.target.setCustomValidity("Pole jest wymagane");
      } else if (e.target.value.length < 3) {
        e.target.setCustomValidity("Minimalna długość zapytania to 3 znaki");
      }
    }
  }

  render() {
    const { isProjectTaskListLoading, isProjectTaskSearching, projectTasks } =
      this.props;
    const budgetYearOptions = this.renderBudgetYearOptions();
    const districtOptions = this.renderDistrictOptions();
    const officeThematicAreaOptions = this.renderOfficeThematicAreaOptions();
    const statusOptions = this.renderStatusOptions();

    return (
      <Fragment>
        {isProjectTaskListLoading && (
          <Loader loading={isProjectTaskListLoading} />
        )}
        {!isProjectTaskListLoading && (
          <Fragment>
            <form onSubmit={this.onSearchClick}>
              <div className="row row--justify-end row--space-10 row--top-15 row--bottom-20 project-tasks__header">
                <Select
                  options={budgetYearOptions}
                  value={this.state.budgetYearId}
                  onSelect={(option) =>
                    this.handleSelect("budgetYearId", option)
                  }
                />
                <Select
                  options={districtOptions}
                  value={this.state.districtId}
                  onSelect={(option) => this.handleSelect("districtId", option)}
                />
                <Select
                  options={officeThematicAreaOptions}
                  value={this.state.officeThematicAreaId}
                  onSelect={(option) =>
                    this.handleSelect("officeThematicAreaId", option)
                  }
                />
                <Select
                  options={statusOptions}
                  value={this.state.status}
                  onSelect={(option) => this.handleSelect("status", option)}
                />
                <div className="field">
                  <input
                    className="field__input"
                    placeholder="Słowa kluczowe"
                    title="Wpisz słowa kluczowe"
                    type="text"
                    value={this.state.searchTerm}
                    onChange={this.handleChange.bind(this)}
                    pattern=".{3,}"
                    onInvalid={this.handleInvalid}
                  />
                </div>
                {!isProjectTaskSearching && (
                  <button
                    id="search-button"
                    className="button button--primary-dark button--16 button--width-auto"
                    type="submit"
                    tabIndex="0"
                    title="Wyszukaj z zastosowanymi filtrami"
                  >
                    <span aria-hidden="true">Wyszukaj</span>
                  </button>
                )}
                {isProjectTaskSearching && (
                  <ButtonLoader
                    isExecuting={isProjectTaskSearching}
                    executingText="Szukanie"
                    color={"#fff"}
                  />
                )}
              </div>
            </form>
            <div className="project-tasks__map">
              <LeafletMap
                keyboard={false}
                ref={(ref) => {
                  this.map = ref;
                }}
                center={{
                  lat: this.state.locationLatitude,
                  lng: this.state.locationLongitude,
                }}
                zoom={this.state.zoom}
                style={{ height: "100%" }}
                onzoomend={this.zoomEnd}
              >
                <TileLayer
                  keyboard={false}
                  attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {map(projectTasks, (projectTask) => {
                  return projectTask.markers.map((marker, index) => (
                    <Marker
                      icon={divIcon({
                        html: `<div class="marker">
                      <svg width="25px" height="41px" viewBox="0 0 48 72" fill="${marker.color}">
                        <path d="M24,0 C11.406,0 0,10.209 0,22.806 C0,35.4 10.407,50.436 24,72 C37.593,50.436 48,35.4 48,22.806 C48,10.209 36.597,0 24,0 L24,0 Z M24,33 C19.029,33 15,28.971 15,24 C15,19.029 19.029,15 24,15 C28.971,15 33,19.029 33,24 C33,28.971 28.971,33 24,33 L24,33 Z"></path>
                      </svg>
                    </div>`,
                        popupAnchor: [-0, -0],
                        iconAnchor: [12.5, 41],
                        iconSize: [25, 41],
                      })}
                      keyboard={false}
                      key={`marker-${index}`}
                      position={{
                        lat: marker.latitude,
                        lng: marker.longitude,
                      }}
                    >
                      <Tooltip
                        key={`tooltip-${index}`}
                        position={{
                          lat: marker.latitude,
                          lng: marker.longitude,
                        }}
                      >
                        {marker.description}
                      </Tooltip>
                      <Popup
                        keyboard={false}
                        key={`popup-${index}`}
                        position={{
                          lat: marker.latitude,
                          lng: marker.longitude,
                        }}
                      >
                        <div className="popup">
                          <div className="popup__description">
                            {marker.description}
                          </div>
                          <div className="popup__link">
                            <NavLink
                              to={`${RouteUrls.Budget.projectTasks.preview}/${projectTask.id}`}
                            >
                              więcej
                            </NavLink>
                          </div>
                        </div>
                      </Popup>
                    </Marker>
                  ));
                })}
              </LeafletMap>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}
